import TypographyParagraph from '../../typography/TypographyParagraph'
import { Tooltip, TooltipRefProps } from 'react-tooltip'
import { useRef } from 'react'
import Image from '#app/components/content/Image'

export default function InstagramTemplate({ instagram }: { instagram: any }) {
	const tooltipCopyInstagramUrl = useRef<TooltipRefProps>(null)
	const tooltipCopyComment = useRef<TooltipRefProps>(null)
	const tooltipCopyIpfsUrl = useRef<TooltipRefProps>(null)
	const tooltipCopyPng = useRef<TooltipRefProps>(null)
	const tooltipCopySignature = useRef<TooltipRefProps>(null)

	const instagramIPFSCID = instagram.properties.ipfsCID

	const extractIPFSCID = (ipfsURL: string) => {
		const ipfsSegments = ipfsURL.split('/')
		return ipfsSegments[ipfsSegments.length - 1]
	}

	return (
		<>
			<div
				id="instagramUrl"
				className="flex flex-row border-b border-textInactiveLight p-4 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark"
				onClick={() => {
					navigator.clipboard.writeText(instagram.properties.url)
					tooltipCopyInstagramUrl.current?.open({
						anchorSelect: '#instagramUrl',
						content: 'Copied!',
					})
					setTimeout(() => {
						tooltipCopyInstagramUrl.current?.close()
					}, 2000)
				}}
			>
				<Tooltip imperativeModeOnly ref={tooltipCopyInstagramUrl} />
				<TypographyParagraph
					size="medium"
					additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
				>
					Social Post URL:
				</TypographyParagraph>
				<TypographyParagraph
					size="medium"
					additionalClasses="ml-2 text-textPrimaryLight dark:text-textPrimaryDark break-all"
				>
					{instagram.properties.url}
				</TypographyParagraph>
			</div>
			<div
				id="comment"
				className="flex flex-row border-b border-textInactiveLight p-4 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark"
				onClick={() => {
					navigator.clipboard.writeText(instagram.properties.description)
					tooltipCopyComment.current?.open({
						anchorSelect: '#comment',
						content: 'Copied!',
					})
					setTimeout(() => {
						tooltipCopyComment.current?.close()
					}, 2000)
				}}
			>
				<Tooltip imperativeModeOnly ref={tooltipCopyComment} />
				<TypographyParagraph
					size="medium"
					additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
				>
					Comment:
				</TypographyParagraph>
				<TypographyParagraph
					size="medium"
					additionalClasses="ml-2 text-textPrimaryLight dark:text-textPrimaryDark"
				>
					{instagram.properties.description}
				</TypographyParagraph>
			</div>
			<div
				id="ipfsUrl"
				className="flex flex-row border-b border-textInactiveLight p-4 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark"
				onClick={() => {
					navigator.clipboard.writeText(instagramIPFSCID)
					tooltipCopyIpfsUrl.current?.open({
						anchorSelect: '#ipfsUrl',
						content: 'Copied!',
					})
					setTimeout(() => {
						tooltipCopyIpfsUrl.current?.close()
					}, 2000)
				}}
			>
				<Tooltip imperativeModeOnly ref={tooltipCopyIpfsUrl} />
				<TypographyParagraph
					size="medium"
					additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
				>
					IPFS CID:
				</TypographyParagraph>
				<TypographyParagraph
					size="medium"
					additionalClasses="ml-2 text-textPrimaryLight dark:text-textPrimaryDark break-all"
				>
					{instagramIPFSCID ? extractIPFSCID(instagramIPFSCID) : ''}
				</TypographyParagraph>
			</div>
			<div
				id="png"
				className="flex flex-row border-b border-textInactiveLight p-4 hover:bg-uiSecondaryLight dark:border-textInactiveDark dark:hover:bg-uiSecondaryDark"
				onClick={() => {
					navigator.clipboard.writeText(instagramIPFSCID || '')
					tooltipCopyPng.current?.open({
						anchorSelect: '#png',
						content: 'Copied!',
					})
					setTimeout(() => {
						tooltipCopyPng.current?.close()
					}, 2000)
				}}
			>
				<Tooltip imperativeModeOnly ref={tooltipCopyPng} />
				<TypographyParagraph
					size="medium"
					additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
				>
					PNG:
				</TypographyParagraph>
				<Image
					className="h-auto w-1/3"
					imageUrl={instagramIPFSCID}
					imageAlt={instagramIPFSCID}
					containerClassName="flex items-center justify-center w-full"
				/>
			</div>
			<div
				id="signature"
				className="flex flex-row p-4 hover:bg-uiSecondaryLight dark:hover:bg-uiSecondaryDark"
				onClick={() => {
					navigator.clipboard.writeText(instagram.signature)
					tooltipCopySignature.current?.open({
						anchorSelect: '#signature',
						content: 'Copied!',
					})
					setTimeout(() => {
						tooltipCopySignature.current?.close()
					}, 2000)
				}}
			>
				<Tooltip imperativeModeOnly ref={tooltipCopySignature} />
				<TypographyParagraph
					size="medium"
					additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
				>
					Signature:
				</TypographyParagraph>
				<TypographyParagraph
					size="medium"
					additionalClasses="ml-2 text-textPrimaryLight dark:text-textPrimaryDark break-all"
				>
					{instagram.signature}
				</TypographyParagraph>
			</div>
		</>
	)
}
